/*=====================================================*/

// Event listener for click on '.top_a_target'
document.querySelectorAll('.top_a_target').forEach(function(target) {
    target.addEventListener("click", function(e) {
        e.preventDefault(); 
        const target_get = this.getAttribute('href');   
        const targetElement = document.querySelector(target_get);
      if (targetElement) {
        const offset = 150;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
        
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
        
        }
    });
});

/*====================================================*/
 // scroll up
window.addEventListener("scroll", function() {
    var scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll >= 400) {
        document.querySelector(".back-to-top").classList.add("show");
    } else {
        document.querySelector(".back-to-top").classList.remove("show");
    }
});

document.querySelector('.blog__back-to-top').addEventListener("click", function(e) {
 e.preventDefault();  
     const target_get = this.getAttribute('href');   
        const targetElement = document.querySelector(target_get);
      if (targetElement) {
          const offset = 150;
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
          
          window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
          });
      }
});

 // helpcenter search

function search_faq(thisElement) {
    var input = thisElement.previousElementSibling.value;
    input = input.toLowerCase();

    if (input !== '') {
        var x = document.querySelectorAll('.faq-ques');
        var display_first = 0;
        for (var i = 0; i < x.length; i++) {
            x[i].closest('.faq_content').style.display = 'none';
            console.log(input);
        }
        for (var i = 0; i < x.length; i++) {
            if (!x[i].innerHTML.toLowerCase().includes(input)) {
                x[i].style.display = 'none';
            } else {
                if (window.innerWidth >= 767) {
                    x[i].style.display = 'block';
                } else {
                    if (display_first === 0) {
                        display_first = 1;
                        x[i].closest('.faq_content').classList.add('selected');
                    }
                }
                x[i].closest('.faq_content').style.display = 'block';
            }
        }
    } else {
        var x = document.querySelectorAll('.faq-ques');
        for (var i = 0; i < x.length; i++) {
            if (window.innerWidth >= 767) {
                x[i].style.display = 'block';
            } else {
                x[i].removeAttribute('style');
            }
            x[i].closest('.faq_content').style.display = 'block';
        }
        return false;
    }
}
document.querySelector('.search_field_help').addEventListener('keyup', function(event) {
    var searchFieldHelp = document.querySelector('.search_field_help');  
    if (event.keyCode === 13) {
        document.querySelector('.search-help-center .search-faq').click();
    }
});

document.querySelectorAll('.search-help-center .search-faq').forEach(function(target) {
    target.addEventListener('click', function(event) {
    var target = this;

    if (this.classList.contains('search-faq')) {
         
        var searchFieldHelpValue = target.previousElementSibling.value;
       
        var targetElement = document.querySelector('.help-center-faq');
        target.previousElementSibling.value = searchFieldHelpValue;
        search_faq(target);
        // Scroll to helpCenterFAQ
      if(targetElement){
          const offset = 150;
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;  
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
        }
      
    }
  });
});

document.querySelector('.search-faq').addEventListener('click', function() {
const targetElement = document.querySelector('.help-center-faq');
  if (targetElement) {
    const offset = 120;
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;  
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
  
});

 // help center chat
if (document.querySelector('.help-center-chat')) {
    var helpBar = document.querySelector('.help_bar');
    var helpCenterChatHTML = document.querySelector('.help-center-chat').innerHTML;
    if (helpBar) {
        helpBar.innerHTML = helpCenterChatHTML;
    }
}
 // help center fixed bar menu
if (window.innerWidth >= 1024) {
    window.addEventListener("scroll", function() {
        var scroll = window.pageYOffset || document.documentElement.scrollTop;

        if (scroll >= 750) {
            document.querySelector(".fixed_bar").classList.add("visible");
            document.querySelector('.help-center-chat').style.display = 'none';
        } else {
            document.querySelector(".fixed_bar").classList.remove('visible');
            document.querySelector('.help-center-chat').style.display = 'block';
        }
    });

    document.querySelector('.help_bar').addEventListener('click', function(event) {
      if (this.classList.contains('selected')){  
            this.classList.remove('selected');
      }else{
         this.classList.add('selected');
      }  
    });
  
} 

document.querySelectorAll('.faq_content-tp').forEach(function(item) {
    item.addEventListener('click', function() {
        var parent = this.parentElement;
        if (parent.classList.contains('active')) {
            parent.classList.remove('active');
        } else {
            parent.classList.add('active');
        }
    });
});